import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RetrievalProgressService } from '../retrieval-progress-service';
import { RetrievalProgressModel } from '../../models/retrieval-progress-model';
import type { RETRIEVAL_STRATEGY } from '../../constants';
import type { RetrievalResult } from '../../types';

@injectable()
export class RetrievalProgressServiceImpl implements RetrievalProgressService {
    constructor(
        @inject(RetrievalProgressModel)
        private readonly _retrievalProgressModel: RetrievalProgressModel,
    ) {}

    setAllResultFinished(): void {
        this._retrievalProgressModel.update((state) => {
            state.result.forEach((result) => {
                result.finished = true;
            });
            return state;
        });
    }

    /**
     * 更新检索结果
     * @param name 检索策略名称
     * @param result 检索结果
     */
    updateResult(name: RETRIEVAL_STRATEGY, result: RetrievalResult): void {
        this._retrievalProgressModel.update((state) => {
            state.result.set(name, result);
            return state;
        });
    }

    /**
     * 获取检索中的策略
     * @returns 检索中的策略
     */
    getRunningStrategies(): RETRIEVAL_STRATEGY[] {
        const model = this._retrievalProgressModel.modelData;
        return model.steps.filter((step) => step.running).map((step) => step.name);
    }

    add(name: RETRIEVAL_STRATEGY, running: boolean): void {
        const currentStep = {
            id: name,
            name: name,
            running: running,
        };
        this._retrievalProgressModel.update((state) => {
            // 如果当前步骤已经存在，则更新其状态
            const stepIndex = state.steps.findIndex((step) => step.id === name);
            if (stepIndex !== -1) {
                state.steps[stepIndex] = currentStep;
            } else {
                state.steps.push(currentStep);
            }
            return state;
        });
    }
}
